import React from "react";
import _ from "lodash";
import { Changes, RaceProgram } from "@tvg/ts-types/Race";
import { AlertInline, Paragraph } from "@tvg/design-system";
import CurrentRaceDetails from "../../CurrentRaceDetails";
import ChangesCardPro from "../ChangesCardPro";
import {
  MainCardWrapper,
  AlertContainer,
  ChangesCardProWrapper
} from "./styled-components";

interface Props {
  currentRace: RaceProgram;
  changes: Changes | undefined;
}

const ChangesMainCard = (props: Props) => {
  const { currentRace, changes } = props;
  return (
    <MainCardWrapper>
      <CurrentRaceDetails currentRace={currentRace} enableCompactView />
      {currentRace.description ? (
        <Paragraph
          color="grey.800"
          qaLabel="race-description"
          mx="space-4"
          mb={changes ? "space-0" : "space-4"}
          fontSize={12}
          lineHeight={15}
        >
          {currentRace.description ?? " "}
        </Paragraph>
      ) : (
        <AlertContainer>
          <AlertInline
            message="Details for this race are not available"
            qaLabel="changes-card-alert"
            variant="informational"
          />
        </AlertContainer>
      )}
      {!_.values(changes).every(_.isEmpty) && (
        <ChangesCardProWrapper hasMarginTop>
          <ChangesCardPro
            changes={changes}
            bettingInterests={currentRace.bettingInterests}
          />
        </ChangesCardProWrapper>
      )}
    </MainCardWrapper>
  );
};

export default ChangesMainCard;
